import { createContext, useContext, useEffect, useState, ReactNode } from "react";
import { Lang, LANGS, translations } from "./translations";

type Ctx = { lang: Lang; setLang: (l: Lang) => void; t: (key: string) => string };
const I18nContext = createContext<Ctx | null>(null);

export const I18nProvider = ({ children }: { children: ReactNode }) => {
  const [lang, setLangState] = useState<Lang>(() => {
    const saved = typeof window !== "undefined" ? (localStorage.getItem("punchink_lang") as Lang | null) : null;
    if (saved && translations[saved] && LANGS.some((l) => l.code === saved)) return saved;
    return "en";
  });

  useEffect(() => {
    const meta = LANGS.find((l) => l.code === lang) ?? LANGS.find((l) => l.code === "en")!;
    document.documentElement.lang = lang;
    document.documentElement.dir = meta.dir;
    localStorage.setItem("punchink_lang", lang);
  }, [lang]);

  const t = (key: string) => translations[lang][key] ?? translations.en[key] ?? key;

  return <I18nContext.Provider value={{ lang, setLang: setLangState, t }}>{children}</I18nContext.Provider>;
};

export const useI18n = () => {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be inside I18nProvider");
  return ctx;
};
